import { toast } from "sonner";
import request from "../../../helpers/request";
import { getUser } from "../../../helpers/user";

export const deleteDocumentacaoAVCB = async (id: number) => {
  const url = `${process.env.REACT_APP_API}/documentacaoAVCB/${id}`;
  const user = getUser();

  if (!user) {
    toast.error("Usuário não autenticado.");
    throw new Error("Usuário não autenticado.");
  }

  const result = await request({ url, method: "DELETE" });

  if (result.status === 200) {
    toast.success("Documento deletado com sucesso.");
    return result.data;
  } else {
    toast.error("Falha ao deletar o arquivo.");
    throw new Error(
      result.data?.message || "Erro desconhecido ao deletar o arquivo.",
    );
  }
};
